/* --- GOOGLE ANALYTICS TRACKING --- */
function trackQuizEvent(eventName, eventParams = {}) {
    if (typeof gtag !== 'undefined') {
        gtag('event', eventName, eventParams);
        console.log('GA4 Event:', eventName, eventParams); // For debugging
    } else if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            'event': eventName,
            ...eventParams
        });
        console.log('DataLayer Event:', eventName, eventParams); // For debugging
    } else {
        console.log('Analytics not loaded:', eventName, eventParams); // For debugging
    }
}

/* --- DATA --- */
const quizData = [
    // Page 1: Age selection with images
    {
        type: 'intro-with-images',
        intro: 'Take This 60-Second Quiz To Personalize Your Hair Removal Plan & Unlock Discounts',
        question: 'How old are you?',
        options: [
            { label: '18 - 28', img: "https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_1.png?v=1769768435" },
            { label: '30-39', img: "https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_2.png?v=1769768436" },
            { label: '40-49', img: "https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_3.png?v=1769768434" },
            { label: '50+', img: "https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_4.png?v=1769768436" }
        ],
        showSkip: true
    },
    // Page 2: Problematic areas (multi-select)
    {
        type: 'multi-select',
        question: 'Which areas of unwanted facial hair are most problematic for you?',
        sub: 'Select all that apply',
        options: [
            { text: 'Upper lip' },
            { text: 'Chin' },
            { text: 'Sideburns' },
            { text: 'Peach fuzz on the cheeks' },
            { text: 'Other' }
        ]
    },
    // Page 3: Current removal method (multi-select)
    {
        type: 'multi-select',
        question: 'How do you currently remove unwanted hair?',
        sub: 'Select all that apply',
        options: [
            { text: 'Shaving' },
            { text: 'Plucking / Tweezing' },
            { text: 'Waxing' },
            { text: 'Threading' },
            { text: 'Laser' },
            { text: 'Hair removal creams (ex. Nair)' },
            { text: 'Other' }
        ]
    },
    // Page 4: How fast stubble shows (list with descriptions)
    {
        type: 'list',
        question: 'How fast does stubble show after hair removal?',
        options: [
            { text: 'Couple hours', description: 'You need to pluck/shave every single day.' },
            { text: 'After 1-2 days', description: 'You can feel the stubble under your fingers, but you can skip a day if needed.' },
            { text: 'After 2+ days', description: 'The stubble can go unnoticed for a few days, but it\'s still a constant concern.' }
        ]
    },
    // Page 5: Biggest struggle (multi-select)
    {
        type: 'multi-select',
        question: 'What\'s your biggest struggle with facial hair removal?',
        sub: 'Select all that apply',
        options: [
            { text: 'Hair grows back too fast' },
            { text: 'Pain and irritation' },
            { text: 'Ingrown hairs' },
            { text: 'It\'s making me too self-conscious' },
            { text: 'Make-up doesn\'t sit right' },
            { text: 'Other' }
        ]
    },
    // Page 6: What to achieve (multi-select)
    {
        type: 'multi-select',
        question: 'What would you like to achieve when it comes to facial hair removal?',
        sub: 'Select all that apply',
        options: [
            { text: 'Slower regrowth' },
            { text: 'Thinner and lighter regrowth' },
            { text: 'No irritation, pain or ingrown hair' },
            { text: 'Facial hair permanently removed' },
            { text: 'Other' }
        ]
    },
    // Page 7: Stats screen
    {
        type: 'custom-stats',
        question: '87,359+ women over 45 have already achieved those results with Kelle Cyperus Rotundus Serum'
    },
    // Page 8: Ethnic background (list with info)
    {
        type: 'list',
        question: 'What is your ethnic background?',
        centerOptions: true,
        options: [
            { text: 'White / Caucasian' },
            { text: 'Arab / Middle Eastern / North African' },
            { text: 'Latino / Hispanic' },
            { text: 'Black / African' },
            { text: 'East Asian' },
            { text: 'South Asian' },
            { text: 'Indigenous / Pacific' },
            { text: 'Mixed / Other' }
        ],
        whyWeAsk: 'Genetic and ethnic background play a big role when it comes to facial hair.'
    },
    // Page 9: Hair type (multi-select)
    {
        type: 'multi-select',
        question: 'What is your hair type?',
        sub: 'Select all that apply',
        options: [
            { text: 'Straight and fine' },
            { text: 'Straight and medium-coarse' },
            { text: 'Wavy and medium-coarse' },
            { text: 'Curly and medium-coarse' },
            { text: 'Curly and coarse' },
            { text: 'Coily and coarse' },
            { text: 'Other' }
        ]
    },
    // Page 10: Skin type (list with info)
    {
        type: 'list',
        question: 'What is your skin type?',
        centerOptions: true,
        options: [
            { text: 'Oily skin' },
            { text: 'Dry skin' },
            { text: 'Mixed skin' },
            { text: 'Sensitive skin' },
            { text: 'Normal skin' }
        ],
        whyWeAsk: 'Skin type and oil production in your skin often determine the reaction you experience after different hair removal methods - ingrown hair, irritation, sensitivity, etc.'
    },
    // Page 11: Skin reactions (multi-select)
    {
        type: 'multi-select',
        question: 'How does your skin react to most hair removal methods?',
        sub: 'Select all that apply',
        options: [
            { text: 'Razor burn' },
            { text: 'Red bumps' },
            { text: 'Irritation / Sensitivity' },
            { text: 'Ingrown hairs' },
            { text: 'Itching / Dryness' },
            { text: 'Dark spots' },
            { text: 'Other' }
        ]
    },
    // Page 12: Info screen
    {
        type: 'custom-info',
        question: 'Genetic and mid-life changes don\'t have to stop you from feeling and looking confident'
    },
    // Page 13: Cause of facial hair (list with info)
    {
        type: 'list',
        question: 'If you\'ve been experiencing excess facial hair growth lately, do you know what\'s causing it?',
        centerOptions: true,
        options: [
            { text: 'Yes' },
            { text: 'Not sure' },
            { text: 'Facial hair has always been a concern' }
        ],
        whyWeAsk: 'Hormones are a main driving factor for unwanted hair growth. But Cyperus Rotundus serum targets the hair follicle, minimizing it and making it dormant without affecting your hormones, no matter if the excess hair growth is caused by hormonal changes or genetics.'
    },
    // Page 14: Hair color (list with info)
    {
        type: 'list',
        question: 'What is your hair color?',
        centerOptions: true,
        options: [
            { text: 'Blonde' },
            { text: 'Brown' },
            { text: 'Black' },
            { text: 'Ginger' },
            { text: 'Grey / White' }
        ],
        whyWeAsk: 'Kelle Cyperus Rotundus serum works for any hair type and color, but depending on the exact type, results might come at a faster or slower rate. However, the ancient botanical cyperus rotundus in this serum has proven its effectiveness on all hair types and colors.'
    },
    // Page 15: Loading screen
    { type: 'loading-screen', question: 'Analyzing your answers' },
    // Page 16: Profile summary
    { type: 'custom-profile', question: 'Summary Of Your Facial Hair Profile' }
];


/* --- STATE MANAGEMENT --- */
let currentStep = 0;
const container = document.getElementById('quiz-quizContainer');
const backBtn = document.getElementById('quiz-backBtn');
const topProgress = document.getElementById('quiz-topProgress');


/* --- INIT --- */
function init() {
    // Track quiz start
    trackQuizEvent('quiz_started', {
        quiz_name: 'Hair Removal Quiz',
        page_path: window.location.pathname
    });
    renderStep();
}


/* --- RENDER LOGIC --- */
function renderStep() {

    // Track step view
    const data = quizData[currentStep];
    trackQuizEvent('quiz_step_viewed', {
        step_number: currentStep + 1,
        step_total: quizData.length,
        question: data.question,
        question_type: data.type
    });

    // Update Progress Bar
    const percent = ((currentStep) / (quizData.length - 1)) * 100;
    topProgress.style.width = `${percent}%`;


    // Handle Back Button visibility - always show
    backBtn.style.display = 'block';


    container.innerHTML = ''; // Clear previous content
    container.className = `quiz-main quiz-step-${currentStep}`; // Add step-specific class


    // Create Header
    const title = document.createElement('h2');
    title.className = 'text-2xl sm:text-3xl md:text-4xl font-bold';
    title.textContent = data.question;
    container.appendChild(title);


    if(data.sub) {
        const sub = document.createElement('p');
        sub.textContent = data.sub;
        sub.style.marginBottom = '20px';
        sub.style.fontSize = '14px';
        sub.style.color = '#666';
        sub.style.fontWeight = '700';
        sub.style.textAlign = 'center';
        container.appendChild(sub);
    }


    // Render based on type
    if (data.type === 'intro-with-images') {
        renderIntroWithImages(data);
    } else if (data.type === 'image-grid' || data.type === 'image-grid-overlay') {
        renderImageGrid(data);
    } else if (data.type === 'list') {
        renderList(data);
    } else if (data.type === 'multi-select') {
        renderMultiSelect(data);
    } else if (data.type === 'custom-profile') {
        renderProfileScreen();
    } else if (data.type === 'custom-graph') {
        renderGraphScreen();
    } else if (data.type === 'custom-info') {
        renderInfoScreen();
    } else if (data.type === 'custom-stats') {
        renderStatsScreen();
    } else if (data.type === 'loading-screen') {
        renderLoadingScreen();
    }
}


function renderIntroWithImages(data) {
    // Hide the auto h2 and create custom intro
    const autoTitle = container.querySelector('h2');
    if (autoTitle) {
        autoTitle.style.display = 'none';
    }


    const intro = document.createElement('p');
    intro.textContent = data.intro;
    intro.style.textAlign = 'center';
    intro.style.fontSize = '16px';
    intro.style.fontWeight = '700';
    intro.style.marginBottom = '20px';
    intro.style.padding = '0 1rem';
    intro.style.lineHeight = '1.4';
    container.appendChild(intro);


    const question = document.createElement('h2');
    question.textContent = data.question;
    question.style.fontSize = '1.5rem';
    question.style.fontWeight = '700';
    question.style.textAlign = 'center';
    question.style.marginBottom = '30px';
    container.appendChild(question);


    const grid = document.createElement('div');
    grid.className = 'quiz-grid-options';


    data.options.forEach(opt => {
        const card = document.createElement('div');
        card.className = 'quiz-img-card';
        card.onclick = () => {
            // Track answer
            trackQuizEvent('quiz_question_answered', {
                step_number: currentStep + 1,
                question: data.question,
                answer: opt.label,
                answer_type: 'single_choice'
            });
            nextStep();
        };


        const img = document.createElement('img');
        img.src = opt.img;


        card.appendChild(img);


        const label = document.createElement('div');
        label.className = 'quiz-img-card-label';
        label.textContent = opt.label;
        card.appendChild(label);


        grid.appendChild(card);
    });
    container.appendChild(grid);


    // Add skip button
    if (data.showSkip) {
        const skipBtn = document.createElement('button');
        skipBtn.className = 'quiz-btn-skip';
        skipBtn.textContent = 'SKIP THIS STEP';
        skipBtn.onclick = () => {
            // Show loading screen before redirect
            showSkipLoadingScreen();
        };
        container.appendChild(skipBtn);
    }


    // Add terms footer for first step
    if (currentStep === 0) {
        const termsFooter = document.createElement('div');
        termsFooter.className = 'quiz-terms-footer';
        termsFooter.innerHTML = 'By clicking any of the options above, you agree with the <a href="#">Terms of Use</a> and <a href="#">Privacy</a>';
        container.appendChild(termsFooter);
    }
}


function renderImageGrid(data) {
    const grid = document.createElement('div');
    grid.className = 'quiz-grid-options';


    data.options.forEach(opt => {
        const card = document.createElement('div');
        card.className = 'quiz-img-card';
        card.onclick = () => {
            // Track answer
            trackQuizEvent('quiz_question_answered', {
                step_number: currentStep + 1,
                question: data.question,
                answer: opt.label,
                answer_type: 'single_choice'
            });
            nextStep();
        };


        const img = document.createElement('img');
        img.src = opt.img;


        card.appendChild(img);


        if(data.type === 'image-grid') {
            const label = document.createElement('div');
            label.className = 'quiz-img-card-label';
            label.textContent = opt.label;
            card.appendChild(label);
        } else {
            const overlay = document.createElement('div');
            overlay.className = 'quiz-img-card-overlay-text';
            overlay.textContent = opt.label;
            card.appendChild(overlay);
        }


        grid.appendChild(card);
    });
    container.appendChild(grid);
}


function renderList(data) {
    const list = document.createElement('div');
    list.className = 'quiz-list-options';


    data.options.forEach(opt => {
        const btn = document.createElement('div');
        btn.className = 'quiz-btn-option';
        if (data.centerOptions) {
            btn.classList.add('quiz-centered-option');
        }
        if (opt.highlighted) {
            btn.classList.add('quiz-highlighted');
        }
        btn.onclick = () => {
            // Track answer
            trackQuizEvent('quiz_question_answered', {
                step_number: currentStep + 1,
                question: data.question,
                answer: opt.text,
                answer_type: 'single_choice'
            });
            nextStep();
        };


        if (opt.icon) {
            const icon = document.createElement('span');
            icon.className = 'quiz-btn-icon';
            // Check if icon is SVG (starts with '<svg')
            if (opt.icon.startsWith('<svg')) {
                icon.innerHTML = opt.icon;
            } else {
                icon.textContent = opt.icon;
            }
            btn.appendChild(icon);
        }


        // Check if option has description
        if (opt.description || opt.info) {
            const content = document.createElement('div');
            content.className = 'quiz-btn-option-content';


            const text = document.createElement('div');
            text.textContent = opt.text;
            content.appendChild(text);


            if (opt.description) {
                const desc = document.createElement('div');
                desc.className = 'quiz-btn-option-description';
                desc.textContent = opt.description;
                content.appendChild(desc);
            }


            btn.appendChild(content);
        } else {
            const text = document.createElement('span');
            text.textContent = opt.text;
            btn.appendChild(text);
        }


        list.appendChild(btn);
    });


    container.appendChild(list);


    // Add "Why we ask" info box if present
    if (data.whyWeAsk) {
        const infoBox = document.createElement('div');
        infoBox.className = 'quiz-btn-option-info';
        infoBox.innerHTML = `<strong>Why we ask</strong><br>${data.whyWeAsk}`;
        container.appendChild(infoBox);
    }
}


function renderMultiSelect(data) {
    const list = document.createElement('div');
    list.className = 'quiz-list-options';


    data.options.forEach(opt => {
        const btn = document.createElement('div');
        btn.className = 'quiz-btn-option quiz-multi-select-option';
        if (opt.highlighted) {
            btn.classList.add('quiz-highlighted');
        }
        btn.onclick = (e) => {
            e.currentTarget.classList.toggle('quiz-selected');
        };


        if (opt.icon) {
            const icon = document.createElement('span');
            icon.className = 'quiz-btn-icon';
            // Check if icon is SVG (starts with '<svg')
            if (opt.icon.startsWith('<svg')) {
                icon.innerHTML = opt.icon;
            } else {
                icon.textContent = opt.icon;
            }
            btn.appendChild(icon);
        }


        const text = document.createElement('span');
        text.textContent = opt.text;
        btn.appendChild(text);


        list.appendChild(btn);
    });
    container.appendChild(list);


    const continueBtn = document.createElement('button');
    continueBtn.className = 'quiz-btn-continue';
    continueBtn.textContent = 'Continue';
    continueBtn.onclick = () => {
        // Check if at least one option is selected
        const selectedOptions = list.querySelectorAll('.quiz-btn-option.quiz-selected');


        if (selectedOptions.length === 0) {
            // Track validation error
            trackQuizEvent('quiz_validation_error', {
                step_number: currentStep + 1,
                question: data.question,
                error: 'no_selection'
            });

            // No option selected - trigger shake animation
            list.classList.remove('quiz-shake'); // Remove class first to allow re-triggering
            void list.offsetWidth; // Force reflow to restart animation
            list.classList.add('quiz-shake');


            // Remove shake class after animation completes
            setTimeout(() => {
                list.classList.remove('quiz-shake');
            }, 500);
        } else {
            // Collect all selected answers
            const answers = Array.from(selectedOptions).map(opt => opt.textContent.trim());
            
            // Track multi-select answer
            trackQuizEvent('quiz_question_answered', {
                step_number: currentStep + 1,
                question: data.question,
                answer: answers.join(', '),
                answer_count: answers.length,
                answer_type: 'multi_select'
            });

            // At least one option selected - proceed to next step
            nextStep();
        }
    };
    container.appendChild(continueBtn);
}


function renderProfileScreen() {
    // Show the h2 title with custom styling
    const title = container.querySelector('h2');
    if (title) {
        title.style.display = 'block';
        title.style.marginBottom = '2rem';
    }


    // Main Card Container with image and info grid
    const mainCard = document.createElement('div');
    mainCard.className = 'quiz-main-profile-card';


    // Profile Image (Desktop and Mobile versions)
    const picture = document.createElement('picture');


    // Mobile version for screens smaller than 768px
    const sourceMobile = document.createElement('source');
    sourceMobile.media = '(max-width: 767px)';
    sourceMobile.srcset = 'https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_11_mobile.png?v=1769768568';
    picture.appendChild(sourceMobile);


    // Desktop version for larger screens
    const img = document.createElement('img');
    img.src = "https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_11_desktop.png?v=1769768566";
    img.className = 'quiz-profile-image';
    img.style.width = '100%';
    img.style.maxWidth = '100%';
    img.style.height = 'auto';
    img.style.borderRadius = '12px';
    img.style.marginBottom = '1.5rem';
    img.alt = 'Profile Summary';
    picture.appendChild(img);


    mainCard.appendChild(picture);


    container.appendChild(mainCard);


    // Info Grid - 2x2 layout with individual cards
    const infoGrid = document.createElement('div');
    infoGrid.className = 'quiz-info-grid';
    infoGrid.innerHTML = `
        <div class="quiz-info-item">
            <div class="quiz-info-icon">
                <img src="https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_12.png?v=1768271569" alt="Follicle Condition" width="30" height="30">
            </div>
            <div class="quiz-info-content">
                <div class="quiz-info-label">Follicle Condition</div>
                <div class="quiz-info-value">Overreactive</div>
            </div>
        </div>
        <div class="quiz-info-item">
            <div class="quiz-info-icon">
                <img src="https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_13.png?v=1768271568" alt="Room For Improvement" width="30" height="30">
            </div>
            <div class="quiz-info-content">
                <div class="quiz-info-label">Room For Improvement</div>
                <div class="quiz-info-value">High</div>
            </div>
        </div>
        <div class="quiz-info-item">
            <div class="quiz-info-icon">
                <img src="https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_14.png?v=1768271569" alt="Impact" width="30" height="30">
            </div>
            <div class="quiz-info-content">
                <div class="quiz-info-label">Impact On Confidence / Appearance</div>
                <div class="quiz-info-value">Noticeable</div>
            </div>
        </div>
        <div class="quiz-info-item">
            <div class="quiz-info-icon">
                <img src="https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_15.png?v=1768271570" alt="Expected Results" width="30" height="30">
            </div>
            <div class="quiz-info-content">
                <div class="quiz-info-label">Visible Improvements Expected In</div>
                <div class="quiz-info-value">4 weeks</div>
            </div>
        </div>
    `;
    container.appendChild(infoGrid);


    // Continue Button
    const btn = document.createElement('button');
    btn.className = 'quiz-btn-continue';
    btn.textContent = 'Continue';
    btn.onclick = () => {
        // Track quiz completion
        trackQuizEvent('quiz_completed', {
            quiz_name: 'Hair Removal Quiz',
            total_steps: quizData.length
        });

        setTimeout(() => {
            window.location.href = 'https://secure.kelleskin.com/kelle-serum/au?utm_source=quiz';
        }, 300);
    };
    container.appendChild(btn);
}


function renderInfoScreen() {
    // Hide the auto-generated h2 title
    const autoTitle = container.querySelector('h2');
    if (autoTitle) {
        autoTitle.style.display = 'none';
    }


    const title = document.createElement('h2');
    title.className = 'quiz-info-screen-title';
    title.textContent = 'Genetic and mid-life changes don\'t have to stop you from feeling and looking confident';
    container.appendChild(title);


    const text = document.createElement('p');
    text.className = 'quiz-info-screen-text';
    text.textContent = 'Thousands of women have already discovered that facial hair doesn\'t have to be a daily or even a weekly task… And certainly not something you have to think about in every social interaction.';
    container.appendChild(text);


    const img = document.createElement('img');
    img.src = "https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_6.png?v=1769768710";
    img.className = 'quiz-info-screen-image';
    container.appendChild(img);


    const btn = document.createElement('button');
    btn.className = 'quiz-btn-continue';
    btn.textContent = 'Continue';
    btn.onclick = () => nextStep();
    container.appendChild(btn);
}


function renderStatsScreen() {
    // Hide the auto-generated h2 title
    const autoTitle = container.querySelector('h2');
    if (autoTitle) {
        autoTitle.style.display = 'none';
    }


    const title = document.createElement('h2');
    title.className = 'quiz-stats-title';
    title.textContent = '87,359+ women over 45';
    container.appendChild(title);


    const subtitle = document.createElement('p');
    subtitle.className = 'quiz-stats-subtitle';
    subtitle.textContent = 'have already achieved those results with Kelle Cyperus Rotundus Serum';
    container.appendChild(subtitle);


    // Stats image
    const circlesContainer = document.createElement('div');
    circlesContainer.className = 'quiz-profile-circles';


    const img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_5.png?v=1769768435';
    img.alt = 'Women who chose Kelle';
    img.style.maxWidth = '100%';
    img.style.height = 'auto';


    circlesContainer.appendChild(img);
    container.appendChild(circlesContainer);


    const btn = document.createElement('button');
    btn.className = 'quiz-btn-continue';
    btn.textContent = 'Continue';
    btn.onclick = () => nextStep();
    container.appendChild(btn);
}


/* --- LOADING LOGIC --- */
function renderLoadingScreen() {
    // Hide the auto h2
    const autoTitle = container.querySelector('h2');
    if (autoTitle) {
        autoTitle.style.display = 'none';
    }


    // Loading steps with icons
    const steps = [
        { img: 'https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_7.png?v=1768271400', text: 'Analyzing answers…' },
        { img: 'https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_8.png?v=1768271400', text: 'Creating a summary…' },
        { img: 'https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_9.png?v=1768271401', text: 'Calculating a time frame for expected results…' }
    ];


    steps.forEach((step, index) => {
        const stepDiv = document.createElement('div');
        stepDiv.className = 'quiz-check-item';
        stepDiv.id = `quiz-loadingStep${index + 1}`;
        stepDiv.innerHTML = `
            <span>
                <span class="quiz-loading-spinner" style="display: inline-block;"></span>
                <img src="${step.img}" class="quiz-loading-step-icon" alt="Step ${index + 1}" style="display: none;">
                ${step.text}
            </span>
        `;
        container.appendChild(stepDiv);
    });


    // Final loading image
    const finalImg = document.createElement('img');
    finalImg.src = 'https://cdn.shopify.com/s/files/1/0979/1999/2150/files/image_10.png?v=1769768687';
    finalImg.className = 'quiz-loading-final-image';
    finalImg.style.marginTop = '30px';
    container.appendChild(finalImg);


    // Big spinner container (hidden initially)
    const bigSpinnerContainer = document.createElement('div');
    bigSpinnerContainer.className = 'quiz-big-spinner-container';
    bigSpinnerContainer.id = 'quiz-bigSpinnerContainer';
    bigSpinnerContainer.style.display = 'none';
    bigSpinnerContainer.innerHTML = `
        <div class="quiz-big-loading-spinner" id="quiz-bigSpinner"></div>
        <div class="quiz-big-check-icon" id="quiz-bigCheck" style="display: none;">✓</div>
    `;
    container.appendChild(bigSpinnerContainer);


    // Start animation sequence
    startLoadingSteps();
}


function startLoadingSteps() {
    const steps = [1, 2, 3];
    let currentStepIndex = 0;


    function processStep(stepIndex) {
        if (stepIndex >= steps.length) {
            // All steps complete, show big spinner
            setTimeout(() => {
                showBigSpinner();
            }, 500);
            return;
        }


        const stepDiv = document.getElementById(`quiz-loadingStep${steps[stepIndex]}`);
        const spinner = stepDiv.querySelector('.quiz-loading-spinner');
        const icon = stepDiv.querySelector('.quiz-loading-step-icon');


        // Make step visible
        stepDiv.classList.add('quiz-active');


        // Show loading spinner for 1 second
        setTimeout(() => {
            // Hide spinner, show icon
            spinner.style.display = 'none';
            icon.style.display = 'inline-block';


            // Move to next step after 0.5 seconds
            setTimeout(() => {
                processStep(stepIndex + 1);
            }, 500);
        }, 1000);
    }


    function showBigSpinner() {
        const bigSpinnerContainer = document.getElementById('quiz-bigSpinnerContainer');
        const bigSpinner = document.getElementById('quiz-bigSpinner');
        const bigCheck = document.getElementById('quiz-bigCheck');


        // Show the container
        bigSpinnerContainer.style.display = 'flex';


        // Show big spinner for 2 seconds
        setTimeout(() => {
            // Hide spinner
            bigSpinner.style.display = 'none';


            // Show check icon with animation
            bigCheck.style.display = 'block';


            // Wait a bit then move to next step
            setTimeout(() => {
                nextStep();
            }, 1000);
        }, 2000);
    }


    // Start with first step
    processStep(0);
}


function handleModalChoice() {
    // Hide modal
    document.getElementById('quiz-loadingModal').style.display = 'none';
}


/* --- SKIP LOADING SCREEN --- */
function showSkipLoadingScreen() {
    // Track skip to product (not an abandonment - they chose to go to product page)
    trackQuizEvent('quiz_skipped_to_product', {
        step_number: currentStep + 1,
        total_steps: quizData.length
    });

    // Clear current content
    container.innerHTML = '';


    // Hide back button during loading
    backBtn.style.display = 'none';


    // Create loading container
    const loadingContainer = document.createElement('div');
    loadingContainer.className = 'quiz-skip-loading-container';
    loadingContainer.style.display = 'flex';
    loadingContainer.style.flexDirection = 'column';
    loadingContainer.style.alignItems = 'center';
    loadingContainer.style.justifyContent = 'center';
    loadingContainer.style.minHeight = '60vh';
    loadingContainer.style.gap = '30px';


    // Loading title
    const title = document.createElement('h2');
    title.textContent = 'Redirecting to your personalized plan...';
    title.style.fontSize = '1.5rem';
    title.style.fontWeight = '700';
    title.style.textAlign = 'center';
    title.style.marginBottom = '20px';
    title.style.opacity = '0';
    title.style.animation = 'quiz-fadeIn 0.5s ease-in forwards';
    loadingContainer.appendChild(title);


    // Spinner wrapper for fade-in effect
    const spinnerWrapper = document.createElement('div');
    spinnerWrapper.style.opacity = '0';
    spinnerWrapper.style.animation = 'quiz-fadeIn 0.5s ease-in 0.3s forwards';


    // Big spinner (keeps its spin animation from CSS)
    const spinner = document.createElement('div');
    spinner.className = 'quiz-big-loading-spinner';
    spinnerWrapper.appendChild(spinner);
    loadingContainer.appendChild(spinnerWrapper);


    // Loading text
    const loadingText = document.createElement('p');
    loadingText.textContent = 'Please wait...';
    loadingText.style.fontSize = '1rem';
    loadingText.style.color = '#666';
    loadingText.style.textAlign = 'center';
    loadingText.style.opacity = '0';
    loadingText.style.animation = 'quiz-fadeIn 0.5s ease-in 0.6s forwards';
    loadingContainer.appendChild(loadingText);


    container.appendChild(loadingContainer);


    // Redirect after 2 seconds
    setTimeout(() => {
        window.location.href = 'https://secure.kelleskin.com/kelle-serum/au?utm_source=quiz';
    }, 2000);
}


/* --- NAVIGATION --- */
function nextStep() {
    if (currentStep < quizData.length - 1) {
        currentStep++;
        renderStep();
    }
}


function prevStep() {
    if (currentStep > 0) {
        // Track back button usage
        trackQuizEvent('quiz_back_button_clicked', {
            from_step: currentStep + 1,
            to_step: currentStep
        });

        currentStep--;
        renderStep();
    }
}

// Track when user leaves the page (drop-off)
window.addEventListener('beforeunload', function() {
    // Only track if they haven't completed the quiz
    if (currentStep < quizData.length - 1) {
        trackQuizEvent('quiz_abandoned', {
            step_number: currentStep + 1,
            total_steps: quizData.length,
            completion_percentage: Math.round((currentStep / (quizData.length - 1)) * 100)
        });
    }
});

// Start Quiz
init();



